import { Component } from '@angular/core';

@Component({
  selector: 'app-cards5-examples-35',
  templateUrl: './cards5-examples-35.component.html'
})
export class Cards5Examples35Component {}
